<base-index-page
  [config]="baseIndexPageConfig"
  [service]="introducersService"
  [idKey]="'introducerId'"
/>
